let formTranslation = {
	required: 'Required',
	pattern: 'Wrong pattern',
	minlength: 'Too short',
	maxlength: 'Too long',
	criteria: 'Too easy',
	isTheSame: 'Not the same as previous',
	send: 'Send',
	cancel: 'Cancel',
	namePlaceHolder: 'Name',
	fullName: 'Full name',
	nameLabel: 'Name',
	login: 'Login',
	loginTitle: 'Login',
	registration: 'Registration',
	stayLoggedIn: 'Stay logged in',
	password: 'Password',
	originalPassword: 'Original password',
	forgetPassword: 'Forgotten password?',
	dontHaveAccount: 'Don`t have an account?',
	haveAccount: 'Already have an account?',
	acceptTermsAndConditions: 'I accept terms and conditions',
	firstName: 'First name',
	lastName: 'Last name',
	saveChanges: 'Save changes',
	subscribe: 'Subscribe',
	phone: 'Phone',
	pwAgain: 'Password again',
	changePw: 'Change password',
	yes: 'Yes',
	ok: 'Ok',
	delete: 'Delete',
	close: 'Close',
	forgottenPasswordTitle: 'Forgotten password',
	sendNewPw: 'Send new password',
	loginError: 'Error on login',
	loginSuccess: 'Login success',
	regError: 'Error on registration',
	loginSuccessRegistrationSuccess: 'Registration and login success',
	loginErrorRegistrationSuccess: 'Registration success, login error',
	forgotPasswordSuccess: 'Email sending success',
	forgotPasswordError: 'Email sending error',
	asSoonAs: "As soon as possible",
	nineToTwelve: "On working days, between 09 and 12",
	twelveToSixteen: "On working days, between 12 and 16",
	sixteenToNineteen: "On working days, between 16 and 19",
	shareLanguageLabel: 'Share language',
	fromNameLabel: 'angol feladó',
	fromNamePlaceHolder: 'feladó placeholder',

	/** Global notifications, errors */

	logoutSuccessNotification: 'Logout success',
	successShareNotification: 'Share success',
	sendNotificationEmail: 'ANGOL - Kérek ajánló üzenetet ha a keresésnek megfelelő új ingatlan kerül fel az oldalra',
	technicalError: 'Technical error',
	noOcResult: 'No result, the nearest offices:',
	hack: 'hack, please log in',
	inactiveProperty: 'Inactive property',
	validationError: 'Hiba az űrlap validáció közben',
	errorOnProfileModification: 'Error on profile modification',
	errorOnPasswordModification: 'Error on password modification',
	greetings: "Welcome"
};

export default formTranslation;
